<template>
  <div class="notification-page">
    <div class="notifications-area">
      <notification-card
        v-for="notice in notificationHistory"
        :key="notice.id"
        :class="{'last-opened': lastOpened === notice.id}"
        :notice="notice"
        :closable="false"
        :show-link="showLink"
        history-mode
        @open="handleOpen"/>
      <div v-if="loading" class="loader">
        <indicator/>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationCard from '@/components/Pages/Notifications/NotificationCard'
import Indicator from '@/components/UIComponents/Custom/Indicator'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Notifications',
  components: {
    Indicator,
    NotificationCard
  },
  data() {
    return {
      currentPage: 1,
      allNotificationLoaded: false,
      loading: true,
      lastOpened: undefined
    }
  },
  computed: {
    ...mapGetters(['activeRoleName', 'scrolledDown', 'notificationHistory']),
    showLink() {
      return ['creator', 'aso_manager'].includes(this.activeRoleName)
    }
  },
  watch: {
    scrolledDown(value) {
      if (value) {
        if (this.loading) return
        this.currentPage++
        this.loadNotifications(this.currentPage)
      }
    }
  },
  methods: {
    ...mapActions(['downloadNotifications', 'cancelRequests', 'clearNotificationsHistory']),
    async loadNotifications() {
      if (this.allNotificationLoaded) return
      this.loading = true
      try {
        const result = await this.downloadNotifications(this.currentPage)
        if (!result) {
          this.allNotificationLoaded = true
        }
      } finally {
        this.loading = false
      }
    },
    handleOpen(id) {
      this.lastOpened = id
    }
  },
  beforeMount() {
    this.loadNotifications()
  },
  beforeUnmount() {
    this.cancelRequests()
    this.clearNotificationsHistory()
  }
}
</script>

<style scoped>

</style>
